import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Input, Layout, MenuProps } from "antd";
const { Header } = Layout;
import "./TopBar.scss";
import { useAuth } from "react-oidc-context";
import { useCallback } from "react";
import { useAppSelector } from "../../../features/redux-store/hooks";
import { isDev } from "../../../utils/dev";

const getItems = (
  email: string,
  handleLogout: () => void,
): MenuProps["items"] => [
  {
    key: "1",
    label: email,
    disabled: true,
  },
  {
    key: "divider",
    type: "divider",
  },
  {
    key: "2",
    title: email,
    label: (
      <a target="_blank" rel="noopener noreferrer" onClick={handleLogout}>
        Se dÃ©connecter
      </a>
    ),
  },
];

const TopBar: React.FC = () => {
  const { user, removeUser, signoutRedirect } = useAuth();
  const authSlice = useAppSelector((state) => state.auth);

  const handleLogout = useCallback(() => {
    removeUser();
    signoutRedirect({
      id_token_hint: user?.id_token,
      post_logout_redirect_uri: window.location.origin,
    });
  }, [removeUser, signoutRedirect, user]);

  const items = getItems(user?.profile.email || "", handleLogout);

  return (
    <Header className="top-bar-container">
      {/* <Input
        prefix={<SearchOutlined />}
        placeholder="Appuyer / pour rechercher"
        style={{ width: 300, margin: "16px 24px" }}
      /> */}
      {isDev && (
        <b>
          [<span className="name">{authSlice?.role}</span>]
        </b>
      )}
      <Dropdown menu={{ items }} trigger={["click"]}>
        <div className="dropdown">
          <Avatar className="avatar" icon={<UserOutlined />} />
          <span className="name">{authSlice?.user?.profile?.name || ""}</span>
          <DownOutlined />
        </div>
      </Dropdown>
    </Header>
  );
};

export default TopBar;
